/**
 * @Author: shenyi
 * @Date:   2022-12-14 09:48:42
 * @Last Modified by:   shenyi
 * @Last Modified time: 2023-03-14 17:48:51
 */
import {axios} from 'marmot_design_ui'

export const getAppInfoApi = () => {
    return axios.request({
      url: "/phoenix/knowledge/api/v1/menu/getGuideTopBarInfo",
      method: "get",
    });
}
// 页面顶部用户信息
export const getLoginUserInfo = () => {
  return axios.request({
      url: '/phoenix/portal/api/v2/pc/loginUser/getLoginUserInfo',
      method:"get",
  })
}